import { gql } from "@apollo/client/core";

/**
 * Whether the current user has already seen the release welcome flow for a given `flowKey`.
 * Backed by the `user_welcome_flow` Hasura table, one row per (user, flowKey). Select permission
 * has no tenant filter — the same Frontegg user switching tenants must still find the row, since
 * "seen" is per user, not per tenant.
 */
const GetUserWelcomeFlowQuery = gql`
  query GetUserWelcomeFlow($flowKey: String!) {
    userWelcomeFlow(where: { flowKey: { _eq: $flowKey } }) {
      userId
      flowKey
      variant
      seenAt
      completedAt
    }
  }
`;

export default GetUserWelcomeFlowQuery;
